export const ZMANIM_METADATA = [
  { key: 648970001, index: 'fast', label: 'תחילת הצום' },
  { key: 648970002, index: 'alot', label: 'עלות השחר' },
  { key: 648970003, index: 'misheyakir', label: 'ציצית ותפילין' },
  { key: 648970004, index: 'netz', label: 'נץ החמה' },
  { key: 648970005, index: 'sz_kriat_shma', label: 'ס"ז קריאת שמע' },
  { key: 648970006, index: 'sz_tfila', label: 'סוף זמן תפילה' },
  { key: 648970007, index: 'hatzot', label: 'חצות היום' },
  { key: 648970008, index: 'mincha', label: 'מנחה גדולה' },
  { key: 648970009, index: 'candles', label: 'הדלקת נרות' },
  { key: 648970010, index: 'sunset', label: 'שקיעה' },
  { key: 648970011, index: 'stars', label: 'צאת הכוכבים' },
  { key: 648970012, index: 'havdalah', label: 'מוצאי שבת' }
];

export const DAY_METADATA = [
  "א'",
  "ב'",
  "ג'",
  "ד'",
  "ה'",
  "ו'",
  "ז'",
  "ח'",
  "ט'",
  'י\'',
  'י"א',
  'י"ב',
  'י"ג',
  'י"ד',
  'ט"ו',
  'ט"ז',
  'י"ז',
  'י"ח',
  'י"ט',
  "כ'",
  'כ"א',
  'כ"ב',
  'כ"ג',
  'כ"ד',
  'כ"ה',
  'כ"ו',
  'כ"ז',
  'כ"ח',
  'כ"ט',
  "ל'"
];

export const MONTH_METADATA = [
  'תשרי',
  'חשוון',
  'כסלו',
  'טבת',
  'שבט',
  'אדר',
  "אדר א'",
  "אדר ב'",
  'ניסן',
  'אייר',
  'סיון',
  'תמוז',
  'אב',
  'אלול'
];

export const ZL_CAUSE_METADATA = ['נפטר', 'נהרג', 'נרצח', 'נפל'];
export const ZL_SUFFIX_METADATA = ["ז\"ל", 'זצ"ל', 'הי"ד'];

export const HEBREW_MONTHS_EN = [
  'Tishrei',
  'Cheshvan',
  'Kislev',
  'Tevet',
  "Sh'vat",
  'Adar',
  'Adar I',
  'Adar II',
  'Nisan',
  'Iyyar',
  'Sivan',
  'Tamuz',
  'Av',
  'Elul'
];
